<template>
  <div
    v-if="accountStore.isLoginMagicLinkFetching"
    class="flex h-screen w-full items-center justify-center"
  >
    <Loader2 class="mr-2 h-4 w-4 animate-spin" />
  </div>
  <template v-else>
    <div class="relative h-dvh overflow-hidden md:overflow-visible">
      <div class="layout-frame container relative z-10 h-full">
        <PageIntro :title="t('login.title')" :subtitle="t('login.subtitle')" />
        <LoginForm class="mx-auto mt-6 lg:mb-10 lg:mt-8" />
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useAccountStore } from '@stores/account.store';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

// Components
import LoginForm from '@modules/LoginForm.vue';
import PageIntro from '@modules/PageIntro.vue';

// Icons
import { Loader2 } from 'lucide-vue-next';

const { t } = useI18n();

const route = useRoute();
const token = computed(() => (route.query.token as string) || '');
const accountStore = useAccountStore();

onMounted(() => {
  if (token.value) {
    accountStore.loginMagicLink(token.value);
  }
});
</script>
